import React from 'react';

import { SellerListing } from './sellerListingsCollectionReducer';

export interface ISellerListingsCollectionState {
  selectedListings: SellerListing[];
  listings: SellerListing[];
  showEmptyState: boolean;
}
interface ISellerListingsCollectionContext {
  listingsCollectionState: ISellerListingsCollectionState;
  dispatch: React.Dispatch<any>;
  useLazySellerListingsQuery: () => any;
}

export default React.createContext<ISellerListingsCollectionContext>({
  listingsCollectionState: null,
  dispatch: () => {},
  useLazySellerListingsQuery: () => {},
});
